var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"browse-container"},[_c('ul',{staticClass:"browse-keyboard"},_vm._l((_vm.labels[_vm.currentLocale]),function(label,index){return _c('li',{key:(label + "-" + index)},[_c('BrowseLink',{attrs:{"path":("/index/" + label),"label":label,"disabled":_vm.processing}})],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-463208df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrowseByIndexPanel/BrowsePanel/BrowsePanel.vue
// module id = null
// module chunks = 